{
  "main": "Main",
  "logo": "Sagecool Logo",
  "workspace": "Workspace",
  "workspaces": "Workspaces",
  "teacher_workspace_title": "{{name}}'s Workspace",
  "school_admin_workspace_title": "{{name}}'s Workspace",
  "student_workspace_title": "{{name}}'s Workspace",
  "search": "Search",
  "home": "Home",
  "logout": "Logout",
  "account": "Account",
  "admin": "Admin",
  "back_to_admin": "Back to admin",
  "back": "Back",
  "breadcrumbs": "Breadcrumbs",
  "menu_for": "User Menu for {{name}}",
  "role_menu": "{{role}} menu",
  "roles": {
    "teacher": "Teacher",
    "school_admin": "School Admin",
    "student": "Student"
  }
}
